import script from "./NotificationToaster.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationToaster.vue?vue&type=script&setup=true&lang=js"

import "./NotificationToaster.vue?vue&type=style&index=0&id=c18f8674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c18f8674"]])

export default __exports__